$(document).ready(function () {
//   window.refreshCartDrawer = function () {
//     $.get(window.location.pathname, function (response) {
//         const updatedCartDrawer = $(response).find('.cart_content--js');

//         if (!updatedCartDrawer.length) {
//         console.warn('Cart drawer section not found');
//         return;
//         }

//         $('.cart_content--js').html(updatedCartDrawer.html());

//         console.log('🛒 Cart drawer refreshed via window.refreshCartDrawer');
//     });
//   };


    window.refreshCartDrawer = function () {
    $.get(window.location.pathname, function (response) {
        const $response = $(response);

        // -------------------------------
        // 1️⃣ Update Cart Drawer Contents
        // -------------------------------
        const updatedCartDrawer = $response.find('.cart_content--js');

        if (!updatedCartDrawer.length) {
        console.warn('Cart drawer section not found');
        } else {
        $('.cart_content--js').html(updatedCartDrawer.html());
        }

        // -------------------------------
        // 2️⃣ Update Cart Icon Bubble
        // -------------------------------
        const updatedCartBubble = $response.find('#cart-icon-bubble');

        if (!updatedCartBubble.length) {
        console.warn('Cart bubble not found in response');
        } else {
        $('#cart-icon-bubble').replaceWith(updatedCartBubble);
        console.log('🛒 Cart icon bubble updated');
        }

        console.log('🛒 Cart drawer refreshed via window.refreshCartDrawer');
    });
    };


  $(document).on("click", ".header__icon--cart", function (evt) {
    evt.preventDefault();
    $(".cd_outer").css("display", "flex");
    setTimeout(function () {
      $(".cd_outer").addClass("active");
    }, 100);
  });


  $(document).on("click", ".gp_cta", function (evt) {
     evt.preventDefault();
      var currentId = $(this).attr('data-id');
      var currentQty = parseFloat($(this).closest('.gp_component').find('.gp_quantity-value').html());

      jQuery.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              id: currentId,
              quantity: currentQty
            },
            success: function () {
              refreshCartDrawer();
              $(".cd_outer").css("display", "flex");
              setTimeout(function () {
                $(".cd_outer").addClass("active");
              }, 100);
            },
          });
        },
      });
      
  });

  $(document).on("submit", ".hm_offer-form", function (evt) {
    evt.preventDefault();

    var currentId = $(this).find('input[name="id"]').attr("value");
    var newSellingPlanId = "";
    var currentQty = $(this).find(".hm_offer-quantity").attr("value");

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
            selling_plan: newSellingPlanId,
          },
          success: function () {
            refreshCartDrawer();
            $(".cd_outer").css("display", "flex");
            setTimeout(function () {
              $(".cd_outer").addClass("active");
            }, 100);
          },
        });
      },
    });
  });

  $(".custom_pp-btn_gp").click(function (e) {
    e.preventDefault();
    var currentId = $(this).attr('data-id');
    var currentQty = $(this).attr('data-qty');

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
          },
          success: function () {
            refreshCartDrawer();
            $(".cd_outer").css("display", "flex");
            setTimeout(function () {
              $(".cd_outer").addClass("active");
            }, 100);
          },
        });
      },
    });
  });

  $(".pdp_offer-card--btn_real").click(function (e) {
    e.preventDefault();
    var currentId = $(this)
      .closest(".hm_offer-form ")
      .find('input[name="id"]')
      .attr("value");
    var currentQty = 1;

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
          },
          success: function () {
            refreshCartDrawer();
            $(".cd_outer").css("display", "flex");
            setTimeout(function () {
              $(".cd_outer").addClass("active");
            }, 100);
          },
        });
      },
    });
  });

  $(document).on("click", ".calm_cart_upsell_btn", function (evt) {
    evt.preventDefault();
    var $btn = $(this);
    $btn.find(".upsell_btn_content").hide();
    $btn.find(".upsell_btn_loader").css("display", "block");

    var mode = $btn.attr("data-mode");
    var currentId = $btn.attr("data-id");
    var currentQty = 1;

    var upsellSource =
      mode === "pp" ? "Upsell from product page" : "Upsell from cart";

    var data = {
      id: currentId,
      quantity: currentQty,
    };

    console.log("Adding upsell product:", data);

    // Step 1: Add product to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Upsell product added:", cart);

        // Step 2: Get current cart
        return fetch("/cart.js").then((response) => response.json());
      })
      .then((cartData) => {
        console.log("Cart data before attribute update:", cartData);

        // Step 3: Merge in the new order attribute
        let updatedAttributes = cartData.attributes || {};
        updatedAttributes["Upsell Source"] = upsellSource;

        // Step 4: Update cart with order attribute
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: updatedAttributes }),
        });
      })
      .then((response) => response.json())
      .then((updatedCart) => {
        console.log("Cart updated with Upsell Source:", updatedCart);

        if (mode === "pp") {
          $(".cd_outer").css("display", "flex");
          setTimeout(() => $(".cd_outer").addClass("active"), 100);
        }

        refreshCartDrawer();
        $btn.find(".upsell_btn_content").show();
        $btn.find(".upsell_btn_loader").hide();
        $(".col_pp_upsell_outer").hide();
      })
      .catch((error) => {
        console.error("Upsell error:", error);
        alert("Something went wrong. Please try again.");
      });
  });

  $(document).on("click", ".cd_item_upgrade_to_sub", function (evt) {
    $(this).html("Upgrading...");

    var newVariantId = $(this).attr("data-id"); // subscription variant ID
    var newSellingPlanId = $(this).attr("data-selling-plan-id");
    var oldLineItemKey = $(this).attr("data-old-id"); // line item key (NOT variant ID)

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: [
          {
            id: newVariantId,
            quantity: 1,
            selling_plan: newSellingPlanId,
          },
        ],
      },
      dataType: "json",

      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: oldLineItemKey,
            quantity: 0,
          },

          success: function () {
            refreshCartDrawer();
          },
        });
      },
    });
  });

  // $(document).on("click", ".cd_item_upgrade_to_sub", function (evt) {
  //   $(this).html("Upgrading...");

  //   var currentId = $(this).attr("data-id");
  //   var newSellingPlanId = $(this).attr("data-selling-plan-id");
  //   var oldId = $(this).attr("data-old-id");

  //   // Update existing item instead of adding/removing
  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/change.js",
  //     data: {
  //       id: oldId, // same ID, so update it
  //       quantity: 1, // keep quantity
  //       selling_plan: newSellingPlanId,
  //     },
  //     success: function () {
  //       refreshCartDrawer();
  //     },
  //   });
  // });

  $(".col_pp_Atc_main__js").click(function () {
    $(this).addClass("loading");
    var currentMode = $(".col_product-mode.active").attr("data");
    var currentId;
    var data;
    var sellingId = $(".col_product_variant.active").attr("data-selling-plan");
    if (currentMode == "sub") {
      currentId = $(".col_product_variant.active").attr("data-sub-id");
      data = {
        id: currentId,
        quantity: 1,
        selling_plan: sellingId,
      };
    } else {
      currentId = $(".col_product_variant.active").attr("data-id");
      data = {
        id: currentId,
        quantity: 1,
      };
    }

    console.log(data);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        $(".cd_outer").css("display", "flex");
        setTimeout(function () {
          $(".cd_outer").addClass("active");
        }, 100);
        refreshCartDrawer();
        $(".col_pp_Atc_main__js").removeClass("loading");
      },
      error: function () {
        alert("Error adding item to the cart.");
        $(".col_pp_Atc_main__js").removeClass("loading");
      },
    });
  });

  $(".cd_outer").click(function (e) {
    if (!$(e.target).closest(".cd_inner").length) {
      $(".cd_outer").removeClass("active");
      setTimeout(function () {
        $(".cd_outer").hide();
      }, 500);
    }
    $('body').removeClass('overflow-hidden');
  });

  $(document).on("click", ".cd_close", function () {
    $(".cd_outer").removeClass("active");
    setTimeout(function () {
      $(".cd_outer").hide();
    }, 500);
    $('body').removeClass('overflow-hidden');

  });

  $(document).on("click", ".cd_item-plus", function () {
    $(this).closest(".cd_item").addClass("loading");
    var currentVal = parseFloat(
      $(this).closest(".cd_item").find(".cd_item-val").html()
    );
    currentVal++;
    var currentId = $(this).closest(".cd_item").attr("data-id");

    var data = {
      id: currentId,
      quantity: currentVal,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        refreshCartDrawer();
      },
    });
  });

  $(document).on("click", ".cd_item-remove", function () {
    $(this).closest(".cd_item").addClass("loading");
    var currentId = $(this).closest(".cd_item").attr("data-id");

    var data = {
      id: currentId,
      quantity: 0,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        refreshCartDrawer();
      },
    });
  });

  $(document).on("click", ".cd_item-minus", function () {
    $(this).closest(".cd_item").addClass("loading");
    var currentVal = parseFloat(
      $(this).closest(".cd_item").find(".cd_item-val").html()
    );
    currentVal--;
    var currentId = $(this).closest(".cd_item").attr("data-id");

    var data = {
      id: currentId,
      quantity: currentVal,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        refreshCartDrawer();
      },
    });
  });


});
